const REFERRAL_STORAGE_KEY = 'nord.referrerPlayerId';

function parseReferrer(value: string | null): number | undefined {
  if (value === null || !/^[1-9]\d*$/.test(value)) return undefined;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : undefined;
}

/** Keep a referral through reloads while the visitor completes registration. */
export function captureReferrer(search: string): number | undefined {
  const linked = parseReferrer(new URLSearchParams(search).get('ref'));
  try {
    if (linked !== undefined) {
      window.sessionStorage.setItem(REFERRAL_STORAGE_KEY, String(linked));
      return linked;
    }
    return parseReferrer(window.sessionStorage.getItem(REFERRAL_STORAGE_KEY));
  } catch {
    return linked;
  }
}

export function clearReferrer(): void {
  try {
    window.sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch {
    // Registration still succeeds when browser storage is unavailable.
  }
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete('ref');
    window.history.replaceState(window.history.state, '', url);
  } catch {
    // URL cleanup must not turn a successful registration into an error.
  }
}

export function referralLink(playerId: number, origin: string): string {
  const url = new URL('/', origin);
  url.searchParams.set('ref', String(playerId));
  return url.href;
}
